var map = {
	"./crie@2x.png": "5530f",
	"./diagnostico@2x.png": "7d11",
	"./download-mockup@2x.png": "a524",
	"./insights@2x.png": "aeb6",
	"./notificacoes@2x.png": "5988",
	"./planejamento@2x.png": "0f9b",
	"./pratices@2x.png": "c88a",
	"./reeducacao@2x.png": "3fea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7808";